import React from "react"
import BlogListCategoriesStyle from "./BlogListCategoriesStyle.module.styl"
import BlogListCategory from "./BlogListCategory"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faAngleDown } from "@fortawesome/free-solid-svg-icons/faAngleDown"
import { faAngleUp } from "@fortawesome/free-solid-svg-icons/faAngleUp"
import translate from "../../../../../../translation/translator"
import keys from "../../../../../../translation/keys"

const BlogListCategories = ({
  categories,
  path,
  width,
  toggleSubCategoriesDropdown,
  subCategoriesDropdown,
  locale,
}) => {
  return (
    <React.Fragment>
      {width <= 992 ? (
        <div className={BlogListCategoriesStyle.mobile_holder}>
          <h2
            /* eslint-disable-next-line */
            role="button"
            tabIndex={0}
            onKeyDown={toggleSubCategoriesDropdown}
            onClick={toggleSubCategoriesDropdown}
            className={BlogListCategoriesStyle.section_title}
          >
            категории{" "}
            {subCategoriesDropdown === false ? (
              <FontAwesomeIcon icon={faAngleDown} />
            ) : (
              <FontAwesomeIcon icon={faAngleUp} />
            )}
          </h2>
          {subCategoriesDropdown && (
            <div className={BlogListCategoriesStyle.mobile_categories_holder}>
              {categories &&
                categories.map((category, index) => (
                  <BlogListCategory
                    path={path}
                    key={index}
                    category={category}
                  />
                ))}
            </div>
          )}
        </div>
      ) : (
        <div className={BlogListCategoriesStyle.holder}>
          <div className={BlogListCategoriesStyle.content}>
            <h2 className={BlogListCategoriesStyle.section_title}>
              {translate(keys.BLOG_CATEGORIES, locale)}
            </h2>
            <div className={BlogListCategoriesStyle.categories_holder}>
              {categories &&
                categories.map((category, index) => (
                  <BlogListCategory
                    path={path}
                    key={index}
                    category={category}
                  />
                ))}
            </div>
          </div>
        </div>
      )}
    </React.Fragment>
  )
}

export default BlogListCategories
